<template>
  <div class="modal contact-modal">
    <div class="overlay"  @click="$emit('closeContactModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeContactModal')" src="./../assets/close.svg"/>
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">Contact Us</div>
              <div class="form-fields-wrapper">
                <label>
                  <div class="desc">Name:</div>
                  <input type="text" placeholder="Enter your name" v-model="name"/>
                </label>
                <label>
                  <div class="desc">Surname:</div>
                  <input type="text" placeholder="Enter your surname" v-model="surname"/>
                </label>
                <label>
                  <div class="desc">E-mail:</div>
                  <input type="email" placeholder="Enter your e-mail" v-model="email"/>
                </label>
                <label>
                  <div class="desc">Phone:</div>
                  <input type="tel" placeholder="Enter your phone" v-model="phone"/>
                </label>
                <label class="full">
                  <div class="desc">Topic:</div>
                  <input type="text" placeholder="Enter topic" v-model="topic"/>
                </label>
                <label class="full">
                  <div class="desc">Message:</div>
                  <textarea placeholder="Enter message" v-model="message"></textarea>
                </label>
                <div class="info">
                    <b>{{ $parent.settings.company_name }}</b>
                    <span>{{ $parent.settings.company_address }}</span>
                    <a :href="'mailto:' + $parent.settings.support_email" v-if="$parent.settings.support_email">{{ $parent.settings.support_email }}</a>
                </div>
                <button @click="submitForm" :class="['button fill', {disabled: $parent.contactLoader}]">
                  <span>Send</span>
                </button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
                <transition name="slide">
                  <div v-if="$parent.successMessage" class="error-desc desc green">{{$parent.successMessage}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactModal',
  props: [],
  components: {
  },
  data: function() {
    return {
      name: '',
      surname: '',
      email: '',
      phone: '',
      topic: '',
      message: ''
    }
  },
  methods: {
    submitForm() {
      let data = {
        "name": this.name,
        "surname": this.surname,
        "email": this.email,
        "phone": this.phone,
        "topic": this.topic,
        "message": this.message
      }
      this.$emit('contactSubmit', data)
    }
  }
}
</script>